export default {"src":"/_next/static/media/failing-infra.40c960d4.svg","height":30,"width":29,"blurWidth":0,"blurHeight":0};